import {AxiosService} from './AxiosServices';
import GlobalConfig from "./GlobalConfig/globalConfig";

import {
    searchDataApi,
    searchStateDataApi,
    searchAllSchemeDataApi,
} from "./repository";
import {docUrl} from "./GlobalConfig/apiPath";

export const baseUrlDrupal=() =>{
    const origin = window.location.origin;
    switch (origin){
        case "https://dev-nsws.investindia.gov.in":
            return 'https://dev-nsws.investindia.gov.in';
        case "https://mpf-nsws.investindia.gov.in":
            return 'https://mpf-nsws.investindia.gov.in';
        case "https://qa-nsws.investindia.gov.in":
            return `https://qa-nsws.investindia.gov.in`;
        case "https://uat-nsws.investindia.gov.in":
            return `https://uat-nsws.investindia.gov.in`;
        case "https://www.ppe.nsws.gov.in":
            return `https://www.ppe.nsws.gov.in`;
        case "https://www.nsws.gov.in":
            return `https://www.nsws.gov.in`;
        case "https://www.demo.nsws.gov.in":
            return `https://www.demo.nsws.gov.in`;
        default:
            return `https://uat-nsws.investindia.gov.in`;
    }
};

class CommonService {
    globalSearchData(param) {
        searchDataApi.params = param;
        const api = new AxiosService(searchDataApi);
        return api.doAjax();
    }
    globalSearchStateData(param) {
        searchStateDataApi.params = param;
        const api = new AxiosService(searchStateDataApi);
        return api.doAjax();
    }
    globalSearchAllSchemeData(param) {
        searchAllSchemeDataApi.url = `${baseUrlDrupal()}/policies?title=${param}`;
        const api = new AxiosService(searchAllSchemeDataApi);
        return api.doAjax();
    }
}

export const commonService = new CommonService();